'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILTER_TYPE = exports.FILTER_TYPE = ['metadata', 'filteredChangeInfo', '@type'];
var FILTERED = exports.FILTERED = ['metadata', 'filteredChangeInfo', 'filtered'];
var AGENT_ID = exports.AGENT_ID = ['metadata', 'filteredChangeInfo', 'agentId'];

var TYPE = exports.TYPE = '@type';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/filtered-change-message-metadata/constants/keyPaths.js
// module id = 371
// module chunks = 2 3